<template>
    <div class="bg-[#66A3FF14] text-white rounded-xl border border-[#FFFFFF1F] p-4">
        <!-- Product Row -->

        <!-- Image -->
        <div class="flex items-center gap-4 mb-4">
            <div class="bg-[#FFFFFF14] rounded-2xl p-1 min-h-[78px] min-w-[78px]">
                <NuxtImg src="/images/product-showcase/iphone.png" alt="iPhone 15" width="70" height="70" loading="lazy" />
            </div>
            <div>
                <h3 class="text-base">Iphone 15</h3>
                <p class="text-sm text-[var(--text-gray)]">Model : Starlight</p>
                <div class="flex justify-between">
                    <p class="text-base font-bold">$124,00</p>
                    <span class="text-gray-400">x2</span>
                </div>
            </div>
        </div>
        <!-- Quantity -->

        <hr class="border-gray-700 mb-4" />

        <!-- Total -->
        <div class="flex items-center justify-between">
            <div>
                <p class="text-sm text-[var(--text-gray)]">Estimate Total</p>
                <p class="text-xl font-bold">$248,00</p>
            </div>
            <Button unstyled class="mt-auto bg-[#FFFFFF33] text-white font-semibold text-xs py-3 px-6 rounded-lg ">
                PAY NOW
            </Button>
        </div>
    </div>
</template>
